import { Bang } from './Bang';
import { Check } from './Check';
import { Checkmark } from './Checkmark';
import { ChevronDown } from './ChevronDown';
import { ChevronLeft } from './ChevronLeft';
import { ChevronRight } from './ChevronRight';
import { Cross } from './Cross';
import { Delete } from './Delete';
import { Edit } from './Edit';
import { Info } from './Info';
import { Error } from './Error';
import { Eye } from './Eye';
import { EyeCrossed } from './EyeCrossed';
import { Logout } from './Logout';
import { Mail } from './Mail';
import { Phone } from './Phone';
import { Plus } from './Plus';
import { Security } from './Security';
import { Success } from './Success';
import { RightArrow } from './Arrow';
import { InvisalignLogo } from './InvisalignLogo';

export default {
  bang: Bang,
  check: Check,
  checkmark: Checkmark,
  chevronDown: ChevronDown,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  cross: Cross,
  delete: Delete,
  edit: Edit,
  error: Error,
  eye: Eye,
  eyeCrossed: EyeCrossed,
  info: Info,
  invisalignLogo: InvisalignLogo,
  logout: Logout,
  mail: Mail,
  phone: Phone,
  plus: Plus,
  rightArrow: RightArrow,
  security: Security,
  success: Success,
};
